import { useTranslation } from "react-i18next";
import Reveal from "@/components/base/Reveal";

export default function About() {
  const { t } = useTranslation();

  return (
    <section className="bg-background-50 py-16 md:py-24">
      <div className="mx-auto max-w-3xl px-6 text-center md:px-10">
        <Reveal>
          <h2 className="font-heading text-3xl leading-tight text-foreground-50 md:text-5xl">
            {t("about.title")}
          </h2>
          <p className="mt-6 font-body text-base leading-relaxed text-secondary-500 md:text-lg">
            {t("about.text")}
          </p>
        </Reveal>
      </div>
    </section>
  );
}